import React from "react";
import { JointBillTableLayout } from "@features/JointBillList/components/JointBillPeriod/components/JointBill/layouts/JointBillTableLayout/JointBillTableLayout";
import { JointBillTableRowLayout } from "@features/JointBillList/components/JointBillPeriod/components/JointBill/layouts/JointBillTableRowLayout/JointBillTableRowLayout";
import { JointBillContext } from "@features/JointBillList/utils";
import { FooterTotalCellSkeleton } from "@features/skeletons/Bills/JointBillTableSkeleton/components/FooterTotalCellSkeleton/FooterTotalCellSkeleton";
import { HeaderNameCellSkeleton } from "@features/skeletons/Bills/JointBillTableSkeleton/components/HeaderNameCellSkeleton/HeaderNameCellSkeleton";
import { HeaderTotalCellSkeleton } from "@features/skeletons/Bills/JointBillTableSkeleton/components/HeaderTotalCellSkeleton/HeaderTotalCellSkeleton";
import { ProviderBillNameCellSkeleton } from "@features/skeletons/Bills/JointBillTableSkeleton/components/ProviderBillNameCellSkeleton/ProviderBillNameCellSkeleton";
import { ProviderBillTotalCellSkeleton } from "@features/skeletons/Bills/JointBillTableSkeleton/components/ProviderBillTotalCellSkeleton/ProviderBillTotalCellSkeleton";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface IBillTableSkeletonProps {
  rowCount?: number;
  isSummaryMode?: boolean;
}

export const JointBillTableSkeleton: React.FC<IBillTableSkeletonProps> = ({
  rowCount = 5,
  isSummaryMode,
}) => {
  return (
    <JointBillContext.Provider value={{ isSummaryMode: !!isSummaryMode }}>
      <JointBillTableLayout
        id={0}
        orderId={0}
        headerNameCell={<HeaderNameCellSkeleton />}
        headerStatusCell={<Skeleton className="h-6 w-36" variant="rounded" />}
        headerTotalCell={<HeaderTotalCellSkeleton />}
        footerTotalCell={<FooterTotalCellSkeleton />}
      >
        {Array(rowCount)
          .fill(0)
          .map((_, index) => (
            <JointBillTableRowLayout
              key={index}
              nameCell={<ProviderBillNameCellSkeleton />}
              statusCell={<Skeleton className="h-6 w-36" variant="rounded" />}
              totalCell={<ProviderBillTotalCellSkeleton />}
            />
          ))}
      </JointBillTableLayout>
    </JointBillContext.Provider>
  );
};
